// extracted by mini-css-extract-plugin
export default {"modalContainer":"legacy_modalContainer__9-dK8","open":"legacy_open__wYUYZ","modal":"legacy_modal__BuVVo","glassBorder":"legacy_glassBorder__t7bWz"};